export enum DepositFiatAction {
  SUCCESS = 'depositFiatSuccess',
  FAILURE = 'depositFiatFailure',
}
